import ApprovePaymentPlanError from './ApprovePaymentPlanError';
class CodeValidationLimitReached extends ApprovePaymentPlanError {
    confirmationCode;
    constructor(confirmationCode, options) {
        super('Code validation limit has reached', options);
        this.confirmationCode = confirmationCode;
    }
}
export default CodeValidationLimitReached;
